import React from 'react';

const ActiveWhiteIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries">
      <div className="vbz-icon-beneficiaries-active-white" />
    </div>
  );
};

export default ActiveWhiteIcon;
